module.exports = __webpack_public_path__ + "static/media/Nov_2025_3.512c6681.webp";